import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {Contract} from "../../../model/contract";
import {Constants} from "../../../utils/constants";
import {ContractsService} from "../../../services/contracts.service";
import {SnackService} from "../../../services/snack.service";
import {SplitCamelCasePipe} from "../../../pipes/split-camel-case.pipe";
import {ApiResponse} from "../../../classes/api-response";
import {AuthService} from "../../../services/auth.service";
import {PatchContract} from "../../../model/patch-contract";
import {hasPermission, User} from "../../../model/user";

@Component({
  selector: 'aw-contract-dialog-status-transition',
  templateUrl: './contract-dialog-status-transition.component.html',
  styleUrls: ['./contract-dialog-status-transition.component.scss']
})
export class ContractDialogStatusTransitionComponent implements OnInit {

  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  generalError?: ApiResponse;
  public selectedStatus = '';
  public contractStatuses = Constants.contractStatuses;
  public statuses: string[] = [];
  public currentStatus?= '';
  loggedUser: User;

  constructor(
    public dialogRef: MatDialogRef<ContractDialogStatusTransitionComponent>,
    private contractService: ContractsService,
    private authService: AuthService,
    private snackService: SnackService,
    private splitCamelCase: SplitCamelCasePipe
  ) {
  }

  _contract?: Contract;

  @Input() set contract(value: Contract | undefined) {
    this._contract = value;
    this.currentStatus = this._contract?.status;
  }

ngOnInit(): void {
  this.loggedUser = this.authService.loggedUser();

  if (this.currentStatus === this.contractStatuses.new) {

    if (hasPermission(this.loggedUser, 'customer')) {
      // Cases 1, 3, 4, 6: customer sends to approvalWaiting
      this.statuses.push(this.contractStatuses.approvalWaiting);
    }

    if (hasPermission(this.loggedUser, 'admin')) {
      // Cases 2, 5, 7: admin pushes to testbedAssociation
      this.statuses.push(this.contractStatuses.testbedAssociation);
    }

  } else if (this.currentStatus === this.contractStatuses.approvalWaiting) {
    // Admin only: customer cannot accept or reject
    if (hasPermission(this.loggedUser, 'admin')) {
      this.statuses.push(this.contractStatuses.rejected);
      if (this._contract?.testbed) {
        // Cases 1, 4: testbed present → accept directly to boxesWaiting
        this.statuses.push(this.contractStatuses.boxesWaiting);
      } else {
        // Cases 3, 6: no testbed → must go through testbedAssociation
        this.statuses.push(this.contractStatuses.testbedAssociation);
      }
    }

  } else if (this.currentStatus === this.contractStatuses.testbedAssociation) {
    // Cases 2, 3, 5, 6, 7: both admin and customer can move to boxesWaiting
    // but only once a testbed has been associated
    if (this._contract?.testbed) {
      this.statuses.push(this.contractStatuses.boxesWaiting);
    }

  } else if (this.currentStatus === this.contractStatuses.expired) {
    if (hasPermission(this.loggedUser, 'admin')) {
      this.statuses.push(this.contractStatuses.closed);
    }
  } else if (this.currentStatus === this.contractStatuses.closed) {
    this.statuses.push(this.contractStatuses.finalized, this.contractStatuses.damageReported);
  } else if (this.currentStatus === this.contractStatuses.damageReported) {
    this.statuses.push(this.contractStatuses.finalized);
  }

  if (hasPermission(this.loggedUser, 'admin')) {
    this.statuses.push(this.contractStatuses.expired);
  }
}

  setStatus(): void {
    this.saving = true;
    const newContract = new PatchContract();
    newContract.status = this.selectedStatus;

    this.contractService.updateContract(newContract, this._contract?.id)
      .subscribe(
        () => {
          this.saving = false;
          this.snackService.success('Contract status set to ' + this.splitCamelCase.transform(this.selectedStatus));
          this.dialogRef.close();
          this.saved.emit();
        },
        error => {
          this.saving = false;
          this.snackService.error(error.message);
          this.generalError = error;
        });
  }
  isAdmin(): boolean {
    return hasPermission(this.loggedUser, 'admin');
  }

}




